"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./MultiSelectInputList.scss");
var IconSvg_1 = require("../../../IconSvg");
var key_press_1 = require("./../../../../../utils/key-press");
var enterIsPressed = key_press_1.KeyPress.enterIsPressed;
var MultiSelectInputList = /** @class */ (function (_super) {
    __extends(MultiSelectInputList, _super);
    function MultiSelectInputList(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function () {
            if (_this.props.onSelect) {
                _this.props.onSelect(_this.props.data.choice, false);
            }
        };
        _this.handleKeyDown = function (e) {
            if (enterIsPressed(e)) {
                var elem = e.target;
                elem.parentElement.parentElement.parentElement.children[0].focus();
                if (_this.props.onSelect) {
                    _this.props.onSelect(_this.props.data.choice, true);
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
            else if (_this.props.handelKeyDown) {
                _this.props.handelKeyDown(e);
            }
        };
        _this.setLiRef = function (element) {
            _this.liRef = element;
        };
        return _this;
    }
    MultiSelectInputList.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var _h = this.props.data, choice = _h.choice, isSelected = _h.isSelected, textData = _h.textData;
        var isHoverClass = '';
        var isHoverFocusClass = '';
        var isListHeightClass = 'type-sm';
        var isComboLi = '';
        var isComboboxBg = false;
        if (this.props.options && ((_a = this.props.options) === null || _a === void 0 ? void 0 : _a.isCombobox)) {
            isHoverClass = ((_b = this.props.options.isCombobox) === null || _b === void 0 ? void 0 : _b.isHoverColor) ? styles.comboHoverColor : '';
            isHoverFocusClass = ((_c = this.props.options.isCombobox) === null || _c === void 0 ? void 0 : _c.isHoverFocusColor) ? styles.comboFocusColor : '';
            isComboboxBg = ((_d = this.props.options.isCombobox) === null || _d === void 0 ? void 0 : _d.isAddBgColor) === true ? true : false;
            isListHeightClass = styles.comboListHeight;
            isComboLi = styles.comboLi;
        }
        var classes = isSelected
            ? [styles.menuItem, styles.menuItemSelected, !isComboboxBg ? " color-ui-dark-gray flex color-cobalt" : " color-ui-dark-gray", isHoverClass, isHoverFocusClass, isComboLi].join(" ")
            : [styles.menuItem, !isComboLi ? " overflow-hidden" : "", isHoverClass, isHoverFocusClass, isComboLi].join(" ");
        var text = choice.displayText
            ? choice.displayText
            : choice.value
                ? choice.value.toString()
                : "No Suggestion";
        var searchLen = ((_g = (_f = (_e = this.props) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.textData) === null || _g === void 0 ? void 0 : _g.length) || 0;
        var subStrIndex = this.props.data && this.props.data.textData
            ? text.toUpperCase().indexOf(this.props.data.textData.toUpperCase())
            : 0;
        /*
        if (textData && subStrIndex !== textData.length) {
            subStrIndex = 0;
        }*/
        var primary1stText = text.substring(0, subStrIndex);
        var primary2ndText = text.substring(subStrIndex, subStrIndex + searchLen);
        var primary3rdText = text.substring(subStrIndex + searchLen, text.length);
        var optionText = React.createElement("span", null, text);
        if (this.props.options && this.props.options.heighlightTextData) {
            optionText = (React.createElement(React.Fragment, null,
                React.createElement("span", { "aria-hidden": "true", className: "" + isListHeightClass, dangerouslySetInnerHTML: {
                        __html: primary1stText
                            ? primary1stText.split(" ").join("&nbsp;")
                            : primary1stText,
                    } }),
                React.createElement("span", { "aria-hidden": "true", className: !isComboboxBg ? " font-bold " + isListHeightClass : isListHeightClass, dangerouslySetInnerHTML: {
                        __html: primary2ndText
                            ? primary2ndText.split(" ").join("&nbsp;")
                            : primary2ndText,
                    } }),
                React.createElement("span", { "aria-hidden": "true", className: "" + isListHeightClass, dangerouslySetInnerHTML: {
                        __html: primary3rdText
                            ? primary3rdText.replace(" ", "&nbsp;")
                            : primary3rdText,
                    } })));
        }
        return (React.createElement("li", { id: text, "data-test-id": this.props.testId, className: classes, role: "menuitem", title: isSelected ? text + "( is selected)" : text, tabIndex: isHoverFocusClass ? -1 : 0, onClick: this.handleClick, "aria-selected": isSelected, ref: this.setLiRef, onKeyDown: this.handleKeyDown },
            React.createElement("div", null, optionText),
            isSelected && !isComboboxBg ? (React.createElement("span", { "aria-hidden": "true", className: styles.checkMark + " text-right flex flex-items-center justify-center " },
                React.createElement(IconSvg_1.default, { size: 24, svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M11.33 26.75l-10-10 1.42-1.42 8.62 8.63 18-18 1.42 1.41z\"/></svg>" }))) : ("")));
    };
    return MultiSelectInputList;
}(React.Component));
exports.default = MultiSelectInputList;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/MultiSelectInput/components/MultiSelectInputList/MultiSelectInputList.js
// module id = 1764
// module chunks = 8